import {
	getContractWithABI,
	getTokenDefinition,
	isAddress,
} from "@bracket/chainography";

import {
	getViemClient,
} from "@bracket/contractor-next";

import type { ValidChainId, } from "@bracket/types";

import type { Config, } from "@wagmi/core";



export declare type BalanceOfProps = {
	address: string;
	config?: Config;
	chainId?: ValidChainId,
}

export const balanceOf = async ({
	address,
	config,
	chainId = 1,
}: BalanceOfProps ): Promise<bigint> => {

	try {

		if(chainId !== 1) {
			console.warn("brktETH::balanceOf is only supported on chain 1, forcing chain 1");
			console.trace();
		}

		if(!isAddress(address))
			throw new Error("invalid address");

		const client = await getViemClient({ config, chainId, });
		const {address: contractAddress,} = getTokenDefinition({ symbol: "BRKTETH", chainId: 1, });
		const [_, abi] = getContractWithABI("ERC20", 1);

		const result = await client.readContract({
			address: contractAddress,
			abi,
			functionName: "balanceOf",
			args: [
				address,
			]
		});

		if(typeof result === "bigint") {
			return result;
		}

		throw new Error("unexpected result - expected bigint");
	}
	catch(err) {

		throw new Error(`@bracket/contractor/brktETH::balanceOf errored - ${err.message}`);
	}
}
